import { FileText } from 'lucide-react';
import ModalBtn from "../../molecules/modalButton/view"
import ButtonAction from "../../atoms/buttonAction/view"
import ButtonLoading from "../../atoms/buttonLoading/view"
import Table from "../../molecules/tablas/view"
import DateSelector from "../../atoms/datepicker/view"
import ProductSearchDropdown from "../../molecules/ArrayRelater/ProductSearchDropdown"

import { useEffect, useState } from "react"
import { EmptyArray } from "../../../app/domain/models/empty/empty"
import { IoMdTrash, IoIosWarning } from "react-icons/io"
import { createNote } from "../../../usecases/notes-usecase"
import { dispatchCustomEvent, listener } from "../../../utils/dispatch"
import { Col, Form, Row } from "react-bootstrap"

import "./style.css"

const NewNote = ({ profile }) => {
    const [formData, setFormData] = useState({
        note_type: '',
        items: [],
        date: new Date()
    })
    const [items, setItems] = useState(EmptyArray)
    const [date, setDate] = useState(new Date())

    useEffect(() => {
        listener('table-notas-create-input-change', handleChange)
    }, [])

    function handleOpen() {
        setItems(EmptyArray)
        setFormData({
            note_type: '',
            items: [],
            date: new Date()
        })
        setDate(new Date())
    }

    function handleChange(event) {
        const { id, name, value } = event.detail.data.target
        setItems((prevItems) => {
            return prevItems.map((item) => {
                if (item.sku === id) { // id is sku in this context
                    return { ...item, [name]: value }
                }
                return item
            })
        })
    }

    function removeItemFromNote(data) {
        setItems(prevItems => {
            var filtered = prevItems.filter((item) => item.sku !== data.sku)
            return filtered.length === 0 ? EmptyArray : filtered
        })
    }

    function addItemToNote(data) {
        setItems(prevItems => {
            if (prevItems === EmptyArray) {
                return [mapItem(data)]
            }
            if (prevItems.filter((item) => item.sku === data.sku).length > 0) {
                dispatchCustomEvent('popup', { message: "El producto ya está en la lista", type: "info" })
                return prevItems
            }
            return [...prevItems, mapItem(data)]
        })
    }

    function handleSave() {
        const payload = {
            ...formData,
            items: items,
            date: date
        }

        if (!payload.note_type) {
            dispatchCustomEvent('popup', { message: "Por favor, elige un tipo de nota", type: "warning" })
            dispatchCustomEvent('loading-btn', null)
            return
        }

        if (items === EmptyArray || items.length === 0) {
            dispatchCustomEvent('popup', { message: "Por favor, añade al menos un producto a la nota", type: "warning" })
            dispatchCustomEvent('loading-btn', null)
            return
        }

        const invalidItems = items.filter(item => item.value <= 0 || item.amount <= 0);
        if (invalidItems.length > 0) {
            dispatchCustomEvent('popup', { message: "El valor y la cantidad de los productos deben ser positivos", type: "warning" })
            dispatchCustomEvent('loading-btn', null)
            return
        }

        createNote("", "", payload).then(() => {
            dispatchCustomEvent('loading-btn', null)
            dispatchCustomEvent('modal-close', null)
            dispatchCustomEvent('update-notes', null)
            localStorage.removeItem('allProducts')
            handleOpen()
        }).catch(() => {
            dispatchCustomEvent('popup', { message: "Error al crear la nota", type: "error" })
            dispatchCustomEvent('loading-btn', null)
        })
    }

    function mapItem(item) {
        return {
            "products_id": item.id,
            "sku": item.sku,
            "value": item.buy_value || 0,
            "amount": item.amount || 1,
            "description": ''
        }
    }

    return (
        <ModalBtn
            id="nota"
            title="Nueva nota"
            icon={<FileText size={20} />}
            onClick={handleOpen}
            style={{ border: 'none', minWidth: '65vw' }}
        >
            <div className="new-note-container">
                <h2 className="new-note-title">Crear Nota de Ajuste</h2>

                {/* Sección 1: Información Básica */}
                <div className="new-note-section-split">
                    <div className="new-note-sidebar">
                        <h3 className="new-note-section-title">Información Básica</h3>
                        <p className="new-note-section-desc">Selecciona la fecha y el tipo de movimiento de inventario.</p>
                    </div>

                    <div className="new-note-form-right">
                        <div className="new-note-fields-row">
                            <Form.Group className="new-note-group-custom">
                                <Form.Label>Fecha de Registro</Form.Label>
                                <DateSelector onChange={(d) => setDate(d)} date={date} />
                            </Form.Group>
                            <Form.Group className="new-note-group-custom">
                                <Form.Label>Tipo de Movimiento</Form.Label>
                                <select
                                    className="new-note-select-premium"
                                    value={formData.note_type}
                                    onChange={(e) => setFormData(pre => ({ ...pre, note_type: e.target.value }))}
                                >
                                    <option value="">Seleccionar tipo...</option>
                                    <option value='input'>Entrada de Almacén</option>
                                    <option value='output'>Salida de Almacén</option>
                                </select>
                            </Form.Group>

                        </div>
                    </div>
                </div>

                <hr className="new-note-separator" />

                {/* Sección 2: Productos y Cantidades */}
                <div className="new-note-section-split">
                    <div className="new-note-sidebar">
                        <h3 className="new-note-section-title">Productos a Ajustar</h3>
                        <p className="new-note-section-desc">Busca y agrega productos asignando sus cantidades y valores.</p>
                    </div>

                    <div className="new-note-form-right">
                        <div className="new-note-search-wrapper">
                            <ProductSearchDropdown profile={profile} onSelected={addItemToNote} />
                        </div>

                        <div className="new-note-table-section">
                            <Table
                                id="notas-create"
                                data={items}
                                maxHeight="300px"
                                headersList={["sku", "value", "amount", "description"]}
                                excludeList={["products_id", "product_id", "id"]}
                                emptyMessage="Aún no has agregado productos a esta nota"
                                allowSearch={false}
                                formats={{
                                    value: { type: 'input', key: 'value', id: "sku" },
                                    amount: { type: 'input', key: 'amount', id: "sku" },
                                    description: { type: 'input', key: 'description', id: "sku" },
                                }}
                            >
                                <ButtonAction
                                    title={<IoMdTrash size={18} />}
                                    onClick={removeItemFromNote}
                                />
                            </Table>
                        </div>

                        <div className="validation-warning">
                            <IoIosWarning size={16} />
                            <span>Los valores y cantidades deben ser positivos</span>
                        </div>
                    </div>
                </div>

                <div className="new-note-footer-actions">
                    <ButtonLoading
                        title={"Generar Nota"}
                        onClick={handleSave}
                        disabled={items === EmptyArray || items.length === 0}
                    />
                </div>
            </div>
        </ModalBtn>
    );
};

export default NewNote;
